$(document).on('click', '.qty-minus', function(){
	var $this = $(this),
	$quantityField = $this.closest('.quantity-grid').find('input'),
	$quantity = parseInt($quantityField.val()),
	$item = $this.closest('.module-product-item');
	if($quantity > 0) {
		$quantity = $quantity - 1;
		$quantityField.val($quantity).trigger('change');
	}
});

$(document).on('click', '.qty-plus', function(){
	var $this = $(this),
	$quantityField = $this.closest('.quantity-grid').find('input'),
	$quantity = parseInt($quantityField.val()),
	$item = $this.closest('.module-product-item');
	$quantity = $quantity + 1;
	$quantityField.val($quantity).trigger('change');
});

$(document).on('input change', '.quantity-grid input', function(){
	var $this = $(this),
	$quantity = $this.val(),
	$item = $this.closest('.module-product-item'),
	$title = $item.find('.product-title').text(),
	$priceFormatted = $item.find('.price').text(),
	$price = $item.find('.price').data('price'),
	$itemPrice = parseInt($quantity) * parseInt($price),
	$variant = $item.data('variant-id');
	$itemPrice = $itemPrice.toFixed(2) / 100;
	$itemPrice = '€' + $itemPrice;
	var $html = '<li data-variant="' + $variant + '" data-quantity="' + $quantity + '" data-price="' + $price + '"><span>' + $quantity + ' ' + $title + '</span><span class="system-separator"></span><span class="system-item-price">' + $itemPrice + '</span></li>';
	$item.find('.cart-update-message').fadeIn(1000);
	setTimeout(function(){
		$item.find('.cart-update-message').fadeOut(1000);
	}, 2000);
	if($('li[data-variant="' + $variant + '"]').length) {
		$('li[data-variant="' + $variant + '"]').remove();
	}
	if($quantity > 0) {
		$('.system-item-list:not(.system-item-ignore)').append($html);
	}
	var $total = 0;
	$('.system-item-list:not(.system-item-ignore) li[data-variant]').each(function(){
		var $this = $(this),
		$quantity = $this.data('quantity'),
		$price = $this.data('price'),
		$itemPrice = parseInt($quantity) * parseInt($price);
		$total = $total + $itemPrice;
	});
	$totalFormatted = $total / 100;
	$totalFormatted = '€' + $totalFormatted;
	$('.total-amount-value').text($totalFormatted);
});

$(document).on('click', '.atc-trigger-system', function(){
	$data = [];
	$('.system-item-list:not(.system-item-ignore) li[data-variant]').each(function(){
		var $this = $(this),
		$quantity = $this.data('quantity'),
		$variant = $this.data('variant');
		$data.push({
			"quantity":$quantity,
			"id":$variant
		});
	});
	$.ajax({
		type:'POST',
		url:'/cart/add.js',
		dataType: 'json',
		data:{
			items:$data
		},
		success:function(){
			window.location.href = '/cart';
		}
	});
});

   $(document).ready(function(){
      $('.testimonial-slider-list').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         dots: true,
      });
     
     $('a[data-slide]').click(function(e) {
       e.preventDefault();
       var slideno = $(this).data('slide');
       $('.testimonial-slider-list').slick('slickGoTo', slideno - 1);
     });
     
    });
